import { TimeReportGuid } from "../types";

export const buildTimeReportQueryKey = (profileId: number | undefined, timeReportGuid: TimeReportGuid) => [
  profileId,
  "time-report",
  timeReportGuid,
];
